// Map-based response cache with TTL expiry and size-capped eviction, shared by sagas
// that batch-fetch per-variable data (variables/visualizations last-value/series fetching).
const CACHE_TTL_MS = 5 * 60 * 1000;
const MAX_CACHE_ENTRIES = 500;

function getCachedResponse(cache, key) {
  const cached = cache.get(key);
  if (!cached) return null;

  const age = Date.now() - cached.timestamp;
  if (age > CACHE_TTL_MS) {
    cache.delete(key);
    return null;
  }

  return cached.data;
}

function setCachedResponse(cache, key, data) {
  // Evict expired entries if cache is getting large
  if (cache.size >= MAX_CACHE_ENTRIES) {
    const now = Date.now();
    for (const [k, entry] of cache) {
      if (now - entry.timestamp > CACHE_TTL_MS) {
        cache.delete(k);
      }
    }
  }

  cache.set(key, {
    data,
    timestamp: Date.now(),
  });
}

export { CACHE_TTL_MS, MAX_CACHE_ENTRIES, getCachedResponse, setCachedResponse };
